import Icon from "@ant-design/icons";

const BackyardSvg = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 24H1.46874H24.5765" stroke="#31493C" strokeMiterlimit="10" />
    <path
      d="M1.46875 15.5931L3.01804 14.0438L4.66131 15.6897V24H1.46875V15.5931Z"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path
      d="M10.6914 15.5931L12.2407 14.0438L13.884 15.6897V24H10.6914V15.5931Z"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path
      d="M20.25 15.5931L21.802 14.0438L23.4452 15.6897V24H20.25V15.5931Z"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path d="M4.75781 18.3962H10.6918" stroke="#31493C" strokeMiterlimit="10" />
    <path d="M4.75781 20.692H10.6918" stroke="#31493C" strokeMiterlimit="10" />
    <path d="M13.8848 18.3962H20.2511" stroke="#31493C" strokeMiterlimit="10" />
    <path d="M13.8848 20.692H20.2511" stroke="#31493C" strokeMiterlimit="10" />
    <path
      d="M6.57601 18.3962C6.57601 18.4365 6.64314 16.4173 6.57601 13.4825C6.19205 13.4772 3.86945 13.4074 2.44099 11.5976C2.13758 11.211 1.35622 10.2229 1.48242 9.028C1.58177 8.06406 2.15906 8.01573 2.61283 6.38857C2.77125 5.82202 2.76051 5.61526 3.05856 4.50364C3.26262 3.7384 3.36466 3.35711 3.50428 3.09935C4.095 2.00383 5.26301 1.57959 5.42411 1.5232C6.82841 1.03452 8.57908 1.46413 9.40071 2.51668C10.166 3.49674 9.49738 4.21634 10.4989 5.84081C10.8158 6.35635 11.1084 6.65171 11.3904 7.38205C11.7367 8.28155 11.734 8.98235 11.734 9.13003C11.7287 9.43882 11.7153 10.0644 11.3904 10.7411C10.9876 11.5842 10.3727 11.9682 9.95115 12.2823C8.34548 13.4825 6.5787 13.4825 6.5787 13.4825V18.3962H6.57601Z"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path
      d="M4.50586 10C4.50586 10 6.29144 12.8999 8.69727 10"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path d="M6.54883 13.5711V11.2888" stroke="#31493C" strokeMiterlimit="10" />
    <path
      d="M18.994 18.074C18.994 18.1143 19.0611 16.0951 18.994 13.1603C18.61 13.155 16.2874 13.0852 14.859 11.2754C14.5555 10.8888 13.7742 9.90065 13.9004 8.70579C13.9997 7.74185 14.577 7.69352 15.0308 6.06636C15.1892 5.49981 15.1785 5.29306 15.4765 4.18144C15.6806 3.41619 15.7826 3.03491 15.9223 2.77714C16.513 1.68163 17.681 1.25739 17.8421 1.201C19.2464 0.712316 20.997 1.14193 21.8187 2.19448C22.5839 3.17453 21.9153 3.89413 22.9169 5.51861C23.2337 6.03414 23.5264 6.3295 23.8083 7.05984C24.1547 7.95934 24.152 8.66015 24.152 8.80783C24.1466 9.11661 24.1332 9.74223 23.8083 10.4189C23.4056 11.262 22.7907 11.646 22.3691 11.9601C20.7634 13.1603 18.9967 13.1603 18.9967 13.1603V18.074H18.994Z"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path
      d="M16.9219 9.67511C16.9219 9.67511 18.7075 12.575 21.1133 9.67511"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path d="M18.9648 13.249V10.964" stroke="#31493C" strokeMiterlimit="10" />
  </svg>
);

const BackyardIcon = (props) => <Icon component={BackyardSvg} {...props} />;

export default BackyardIcon;
